// extracted by mini-css-extract-plugin
export var card = "_v6-0";
export var details = "_v6-1";